import React from "react";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";

/**
 * Reusable block-with-confirm modal for VIN duplicate detection.
 *
 * Used by both create forms (Guard 2 — pre-submit) and the main job view
 * (Guard 3 — pre-invoice). Lists the matching same-VIN jobs and requires an
 * explicit confirm to proceed; Cancel aborts the pending action.
 *
 * Props:
 *   show         boolean
 *   title        header text
 *   intro        short sentence above the list
 *   matches      array of rows: { request_id, current_state, locationName,
 *                created_date, requestor_name }
 *   confirmLabel text for the proceed button (e.g. "Create anyway")
 *   onConfirm    () => void   proceed with the acknowledged action
 *   onCancel     () => void   abort
 */
const formatState = (s) => {
  const v = String(s || "").trim();
  return v ? v.charAt(0).toUpperCase() + v.slice(1) : "Unknown";
};

const formatDate = (d) => {
  if (!d) return "";
  const m = moment(d);
  return m.isValid() ? m.format("MMM D, YYYY") : "";
};

const DuplicateVinModal = ({
  show,
  title,
  intro,
  matches = [],
  confirmLabel = "Create anyway",
  onConfirm,
  onCancel,
}) => (
  <Modal show={show} onHide={onCancel} centered>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="alert alert-warning">
        {intro}
      </div>
      <ul className="list-group">
        {matches.map((m) => {
          const date = formatDate(m.created_date);
          return (
            <li className="list-group-item" key={m.request_id}>
              <div className="d-flex justify-content-between align-items-center">
                <strong>Request #{m.request_id}</strong>
                <span className="badge badge-secondary">{formatState(m.current_state)}</span>
              </div>
              <div className="text-muted" style={{ fontSize: "13px" }}>
                {m.locationName || "—"}
                {date ? ` · submitted ${date}` : ""}
                {m.requestor_name ? ` · by ${m.requestor_name}` : ""}
              </div>
            </li>
          );
        })}
      </ul>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="warning" onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default DuplicateVinModal;
